// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* POP-UP STYLING */
.YVtFikStGVklsa2JlLmK {
  width: clamp(235px, 10vw, 384px);
  overflow-x: clip;
  border-radius: var(--map-popup-border-radius);
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.25);
  border: 0.125rem solid #333;
  user-select: none;
  -webkit-user-select: none;
}

.MoZPri4fuu4uGhqelnwA {
  pointer-events: none;
  overflow: hidden;
  border-radius: var(--map-popup-border-radius) var(--map-popup-border-radius) 0 0;
  transition: opacity 150ms ease;
}

#map-container.gw-map-dragging .MoZPri4fuu4uGhqelnwA {
  opacity: 0.85;
}

.qf6V_zPYih0Xb9r1UviD {
  width: 100%;
  height: auto;
  line-height: 0;
  border-bottom: 0.125rem solid #00c49a;
  box-shadow: 0 0 0.25rem #333;
}

.VUjBfUxosA9B51ZuPsEe {
  width: 100%;
}

.dVKE_N2arZja04T_GAg2 {
  padding: 0;
  pointer-events: auto;
  background-color: #eeeffc;
  border-radius: 0 0 var(--map-popup-border-radius) var(--map-popup-border-radius);
  overflow: hidden;
}

.eyHS9wSd2uUnXMmqh_HX {
  background: var(--ocean-gradient);
  padding: 0.25rem 0 0.625rem 0.5rem;
}

.b1nGlpbPUuUmSS7st9NX {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 0.5rem;
  padding-bottom: 1rem;
  gap: 0.75rem;
}

#gw-map button.QHzbG2lKjdfONa_ePtcw {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.33rem;
  border-radius: var(--map-popup-border-radius);
  border: 1px solid #ccc;
}

#gw-map button.QHzbG2lKjdfONa_ePtcw:hover {
  background-color: rgba(221, 222, 235, 0.33);
}

#gw-map button.QHzbG2lKjdfONa_ePtcw svg {
  flex: 0 1 25%;
}

.JFzl04XdHVF_uwk8AANg {
  align-self: center;
  margin-left: 0.5rem;
  font-size: 1rem;
  line-height: 1.2em;
}

button.QHzbG2lKjdfONa_ePtcw[data-active="true"] .JFzl04XdHVF_uwk8AANg {
  font-weight: 700;
}

.kfAf7xPRxv0u7FPpjMVV,
.xM_Vm76JcSg4ZzPVJ3Na {
  --h2-heading-color: #ffffff;
  --body-text-color: #cccccc;
}

.xM_Vm76JcSg4ZzPVJ3Na {
  font-style: italic;
}

.WEbdQrRmA7m04_9TlaOl {
  padding: 1rem 0.5rem 0.25rem 0.5rem;
  display: flex;
  flex-flow: column nowrap;
}

#gw-map h3.map-heading.RBWvk543fRYJRlV9hlSM {
  margin-bottom: 0.25rem;
}

.YVtFikStGVklsa2JlLmK .gw-fullDateContainer {
  pointer-events: none;
}

.YVtFikStGVklsa2JlLmK .gw-fullDateContainer button {
  pointer-events: auto;
  transition: opacity 150ms ease;
}

#map-container.gw-map-dragging .YVtFikStGVklsa2JlLmK .gw-fullDateContainer {
  opacity: 0.85;
}

.aNToMl8xiRaXE1rsxTlQ {
  --font-size: var(--map-small-body-font-size);
}

.W80Hdc7APuqdLNGws5vg {
  padding: 15px;
}

.YVtFikStGVklsa2JlLmK > p {
  margin: 1pt;
}

.HSuw1AZqZyo5OfkK4b6m {
  font-size: 8pt;
  width: 45%;
  padding-right: 5px;
}

.QWEIPl0OVniNMq_Hwt_I {
  transform: rotate(180deg);
}

.vSoR0NqOgJfTnb1E9TvV {
  margin: none;
}

.rBeqnHEbqOHnJY6lC1K4 {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../core/components/popups/SubjectPopupContent.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gCAAgC;EAChC,gBAAgB;EAChB,6CAA6C;EAC7C,yCAAyC;EACzC,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gFAAgF;EAChF,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,qBAAqB;EACrB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* POP-UP STYLING */\r\n.popUp {\r\n  width: clamp(235px, 10vw, 384px);\r\n  overflow-x: clip;\r\n  border-radius: var(--map-popup-border-radius);\r\n  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.25);\r\n  border: 0.125rem solid #333;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n}\r\n\r\n.popUpFeatureArea {\r\n  pointer-events: none;\r\n  overflow: hidden;\r\n  border-radius: var(--map-popup-border-radius) var(--map-popup-border-radius) 0 0;\r\n  transition: opacity 150ms ease;\r\n}\r\n\r\n:global(#map-container.gw-map-dragging) .popUpFeatureArea {\r\n  opacity: 0.85;\r\n}\r\n\r\n.imageContainer {\r\n  width: 100%;\r\n  height: auto;\r\n  line-height: 0;\r\n  border-bottom: 0.125rem solid #00c49a;\r\n  box-shadow: 0 0 0.25rem #333;\r\n}\r\n\r\n.popUpImage {\r\n  width: 100%;\r\n}\r\n\r\n.popUpContent {\r\n  padding: 0;\r\n  pointer-events: auto;\r\n  background-color: #eeeffc;\r\n  border-radius: 0 0 var(--map-popup-border-radius) var(--map-popup-border-radius);\r\n  overflow: hidden;\r\n}\r\n\r\n.popUpHeader {\r\n  background: var(--ocean-gradient);\r\n  padding: 0.25rem 0 0.625rem 0.5rem;\r\n}\r\n\r\n.popUpButtonsContainer {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  align-items: center;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n  margin-bottom: 0.5rem;\r\n  padding-bottom: 1rem;\r\n  gap: 0.75rem;\r\n}\r\n\r\n:global(#gw-map) button.popUpButton {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  padding: 0.33rem;\r\n  border-radius: var(--map-popup-border-radius);\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n:global(#gw-map) button.popUpButton:hover {\r\n  background-color: rgba(221, 222, 235, 0.33);\r\n}\r\n\r\n:global(#gw-map) button.popUpButton svg {\r\n  flex: 0 1 25%;\r\n}\r\n\r\n.popUpButtonText {\r\n  align-self: center;\r\n  margin-left: 0.5rem;\r\n  font-size: 1rem;\r\n  line-height: 1.2em;\r\n}\r\n\r\nbutton.popUpButton[data-active=\"true\"] .popUpButtonText {\r\n  font-weight: 700;\r\n}\r\n\r\n.subjectName,\r\n.species {\r\n  --h2-heading-color: #ffffff;\r\n  --body-text-color: #cccccc;\r\n}\r\n\r\n.species {\r\n  font-style: italic;\r\n}\r\n\r\n.popUpBody {\r\n  padding: 1rem 0.5rem 0.25rem 0.5rem;\r\n  display: flex;\r\n  flex-flow: column nowrap;\r\n}\r\n\r\n:global(#gw-map) h3:global(.map-heading).summaryHeading {\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.popUp :global(.gw-fullDateContainer) {\r\n  pointer-events: none;\r\n}\r\n\r\n.popUp :global(.gw-fullDateContainer) button {\r\n  pointer-events: auto;\r\n  transition: opacity 150ms ease;\r\n}\r\n\r\n:global(#map-container.gw-map-dragging) .popUp :global(.gw-fullDateContainer) {\r\n  opacity: 0.85;\r\n}\r\n\r\n.summaryText {\r\n  --font-size: var(--map-small-body-font-size);\r\n}\r\n\r\n.nameContainer {\r\n  padding: 15px;\r\n}\r\n\r\n.popUp > p {\r\n  margin: 1pt;\r\n}\r\n\r\n.date {\r\n  font-size: 8pt;\r\n  width: 45%;\r\n  padding-right: 5px;\r\n}\r\n\r\n.arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.ulList {\r\n  margin: none;\r\n}\r\n\r\n.mapboxgl-popup-close-button {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popUp": `YVtFikStGVklsa2JlLmK`,
	"popUpFeatureArea": `MoZPri4fuu4uGhqelnwA`,
	"imageContainer": `qf6V_zPYih0Xb9r1UviD`,
	"popUpImage": `VUjBfUxosA9B51ZuPsEe`,
	"popUpContent": `dVKE_N2arZja04T_GAg2`,
	"popUpHeader": `eyHS9wSd2uUnXMmqh_HX`,
	"popUpButtonsContainer": `b1nGlpbPUuUmSS7st9NX`,
	"popUpButton": `QHzbG2lKjdfONa_ePtcw`,
	"popUpButtonText": `JFzl04XdHVF_uwk8AANg`,
	"subjectName": `kfAf7xPRxv0u7FPpjMVV`,
	"species": `xM_Vm76JcSg4ZzPVJ3Na`,
	"popUpBody": `WEbdQrRmA7m04_9TlaOl`,
	"summaryHeading": `RBWvk543fRYJRlV9hlSM`,
	"summaryText": `aNToMl8xiRaXE1rsxTlQ`,
	"nameContainer": `W80Hdc7APuqdLNGws5vg`,
	"date": `HSuw1AZqZyo5OfkK4b6m`,
	"arrow": `QWEIPl0OVniNMq_Hwt_I`,
	"ulList": `vSoR0NqOgJfTnb1E9TvV`,
	"mapboxglPopupCloseButton": `rBeqnHEbqOHnJY6lC1K4`
};
module.exports = ___CSS_LOADER_EXPORT___;
